module.exports = __webpack_public_path__ + "static/img/no-points.773ec04f.png";